{
    "ACDStatusHotKeys_Success_Available": "L'agente \"{}\" è disponibile",
    "ACDStatusHotKeys_Success_Unavailable": "L'agente \"{}\" non è disponibile",
    "ACDStatusHotKeys_Error_CannotSetUserToAvailable": "Impossibile impostare \"{}\" come disponibile.\nL'agente potrebbe essere già disponibile o aver firmato per uscire.",
    "ACDStatusHotKeys_Error_CannotSetUserToUnavailable": "Impossibile impostare \"{}\" come non disponibile.\nL'agente potrebbe essere già indisponibile o aver firmato per uscire.",
    "NAME": "ACDStatusHotKeys"
}